import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgImgTabbarBg = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 119,
	height: 72,
	fill: "#ffffff",
	viewBox: "0 0 297.39 180.01",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M8.37 0.71c18.22,3.95 32.79,17.58 37.94,35.5 14.82,51.66 20.68,105.6 94.81,105.6l15.18 0c74.11,0 79.95,-53.97 94.82,-105.6 5.14,-17.92 19.72,-31.55 37.94,-35.5l3.27 -0.71 5.06 0 0 180.01 -297.39 0 0 -180.01 5.1 0 3.27 0.71z" })
});
export default SvgImgTabbarBg;
